import React from 'react';
import { Routes, Route } from '@leagueplatform/routing';

import { GlossaryComponent } from './components/glossary';

export const InsuranceGlossaryRoutes = () => (
  <Routes>
    <Route index element={<GlossaryComponent />} />
  </Routes>
);
